import client from '@/apis/client';
import type { Response } from '@/types/client.types';
import type {
  NoticesPopup,
  GetNoticesRequestProps,
  Notices,
  UploadNoticeRequestProps,
  ModNoticeRequestProps,
  DelNoticeRequestProps,
  LandingPopupData,
} from '@/types/notices.types';

export const getLandingPopup = () =>
  client
    .get<Response<LandingPopupData | null>>('/notify/landing-popup')
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching landing popup:', error);
      throw error;
    });

export const getNoticePopup = () =>
  client
    .get<Response<NoticesPopup[]>>('/notify/show?platform=web')
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching notices popup:', error);
      throw error;
    });

export const getNotices = (body: GetNoticesRequestProps) =>
  client
    .get<Response<Notices>>('/notify/board', {
      params: { ...body },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching notices:', error);
      throw error;
    });

export const uploadNotice = (body: UploadNoticeRequestProps) =>
  client
    .post<Response<void>>('/notify/board/upload', body)
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error uploading notice:', error);
      throw error;
    });

export const modNotice = (body: ModNoticeRequestProps) =>
  client
    .put<Response<void>>('/notify/board/mod', body)
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error modifying notice:', error);
      throw error;
    });

export const delNotice = (body: DelNoticeRequestProps) =>
  client
    .delete<Response<void>>('/notify/board/del', { data: body })
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error deleting notice:', error);
      throw error;
    });
